"use client";
import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import AboutHeroSection from "@/components/AboutHeroSection";
import cloud from "../../public/assets/images/services/cloud-services/cloud.png";
import Image from "next/image";
import {
  cloudServices,
  cloudTechnologies,
  cloudTimeLine,
} from "../../utils/libs/utils";
const ServiceBox = ({ title, description, points }) => (
  <div className="service-inner-box w-100 ">
    <h3>{title}</h3>
    <p>{description}</p>
    <ul>
      {points.map((point, index) => (
        <li key={index}>{point}</li>
      ))}
    </ul>
  </div>
);

const Cloud = () => {
  useEffect(() => {
    const reveal = () => {
      document.querySelectorAll(".reveal").forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !el.classList.contains("active")
        ) {
          el.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // run on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
    <div>
      <AboutHeroSection
        pillText="~ Our Tech Stack ~"
        title="Cloud Development Services with"
        highlight="Neoverce"
        description="Cloud technologies are at the forefront of digital transformation, enabling businesses to scale, innovate, and adapt in real time. At Neoverce, we deliver tailored cloud solutions that combine agility, security, and efficiency to accelerate your business growth. From seamless migration to custom cloud application development, our expertise ensures your journey to the cloud is smooth and impactful."
        imageAlt="Cloud Development Services"
        image={cloud}
      />
      <div className="py-5">
        <Container>
          <Row className="justify-content-center gy-4">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Scalable and Secure <span>Cloud Development Services</span>
              </h3>
              <p className="reveal fade-bottom">
                We offer a wide range of cloud services to help businesses
                harness the power of the cloud, optimize operations, and achieve
                greater scalability. Our expert team is here to provide tailored
                solutions that ensure seamless cloud adoption, robust
                infrastructure management, and secure, high-performance
                applications.
              </p>
            </Col>

            {cloudServices.map((service, idx) => (
              <Col
                md={6}
                sm={12}
                key={idx}
                className="d-flex reveal fade-bottom"
              >
                <ServiceBox {...service} />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="service-section-bg my-5">
        <Container>
          <Row className="gy-4 justify-content-center">
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Leading Tools Powering <span>Our Cloud Solutions</span>
              </h3>
              <p className="reveal fade-bottom">
                We leverage top cloud platforms like AWS, Microsoft Azure, and
                Google Cloud to ensure your business thrives in a secure,
                high-performance cloud environment. Our expertise spans across
                SaaS, PaaS, and IaaS models, ensuring custom cloud development
                that meets your business needs, enhances efficiency, and drives
                innovation.
              </p>
            </Col>

            {cloudTechnologies.map((tech, index) => (
              <Col
                key={index}
                lg={2}
                md={3}
                sm={4}
                xs={6}
                className="reveal fade-bottom d-flex"
              >
                <div className="tech-image-box text-center">
                  <Image
                    height={100}
                    width={100}
                    alt={tech.alt}
                    src={tech.src}
                    className="img-fluid"
                  />
                  <h3>{tech.name}</h3>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
      <div className="mt-5 py-5">
        <Container>
          <Row>
            <Col md={12} className="text-center">
              <h3 className="com-title reveal fade-bottom">
                Our Proven Cloud <span>Development Process</span>
              </h3>
              <p className="reveal fade-bottom">
                We have refined a cloud development process that is interactive,
                adaptable, and centered around your needs, ensuring every phase
                aligns with your specific goals. Here’s an overview of how we
                approach cloud development to deliver the best results for your
                business.
              </p>
            </Col>
          </Row>
          <div className="py-5">
            <Row className="timeline zipzap gx-0 position-relative">
              {cloudTimeLine.map((step, i) => {
                const isFirst = i === 0;
                const isLast = i === cloudTimeLine.length - 1;

                const timelineRowClass =
                  `timeline-row d-flex align-items-center pb-5 position-relative
            ${isFirst ? "first-timeline" : ""}
            ${isLast ? "last-timeline" : ""}
          `.trim();

                return (
                  <Col key={i} md={12} className={timelineRowClass}>
                    {i % 2 === 0 ? (
                      <>
                        <Col
                          md={6}
                          className="d-flex justify-content-center even-section align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="timeline-box text-box ms-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                      </>
                    ) : (
                      <>
                        <Col md={6} className="text-md-end">
                          <div className="timeline-box text-box me-md-5 reveal fade-right">
                            <div className="timeline-icon d-flex d-md-none w-fit-content mb-3 mt-0">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                          </div>
                        </Col>
                        <Col
                          md={6}
                          className="d-flex justify-content-center align-items-center position-relative reveal fade-left d-none d-md-block"
                        >
                          <div className="timeline-icon-wrapper">
                            <span className="timeline-circle"></span>
                            <div className="timeline-line"></div>
                            <div className="timeline-icon">
                              <Image
                                src={step.icon}
                                alt={step.title}
                                width={50}
                                height={50}
                              />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}
                  </Col>
                );
              })}
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Cloud;
